<template>
  <div class="yj-frame-main">
    <div class="up-banner">
      <div class="product">
        <h3>
          <typed-ment id="bdwg" strings="北斗5G智能数据采集仪"></typed-ment>
        </h3>
        <img class="proImg" src="../../assets/image/product/002.png" alt="">
        <h4>联系我们</h4>
        <contact-us></contact-us>
      </div>
    </div>
  </div>
</template>
<script>
import contactUs from '@/components/contactUs.vue'
export default {
  name: "bdwg",
  components: {
    contactUs,
  },
  data(){
    return {
     
    }
  },
  mounted() {
   
  },
  methods: {
   
  },
}
</script>
<style lang="scss" scoped>
.up-banner{
  background:url("~@/assets/image/product/5g.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
	width: 100%;
  height: calc(100vh - 80px);
  .proImg{
    width: 400px;
    top: 20%;
  }
}
</style>